<template>
    <div class="settlement" >
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" :disabled="loading" size="mini">
                    <el-form-item label="公司名称" prop="comcompanyspanyIds" label-width="70px"  >
                        <el-select filterable  collapse-tags clearable size="mini" mul v-model="searchForm.companyId"   placeholder="公司名称"  style="width: 300px">
                            <el-option
                                v-for="item in companys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="子订单" label-width="70px">
                        <el-input v-model="searchForm.orderNo" placeholder="子订单" size="mini" clearable
                            style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="结算日期">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                                        end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"  clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="doSearch()" size="mini">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <RightToolBar :showSearch="showSearch"  @reDrawTable="reDrawTable"
                                      :columns="dropCol" ></RightToolBar>
                    </el-form-item>
            </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    :key = "updateTable"
                    row-key="id"
                    ref="dataTable"
                    size="mini"
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column type="selection" width="55" fixed/>
                    <el-table-column class-name="drag"
                                     width="auto"
                                     min-width="220"
                                     v-if="dropCol[0].isShow"
                                     :key="dropCol[0].id"
                                     :prop="dropCol[0].prop"
                                     :label="dropCol[0].label" >
                    </el-table-column>
                    <el-table-column class-name="drag"
                                     width="auto"
                                     min-width="220"
                                     v-if="dropCol[1].isShow"
                                     :key="dropCol[1].id"
                                     :prop="dropCol[1].prop"
                                     :label="dropCol[1].label" >
                    </el-table-column>
                    <el-table-column width="auto"
                                     min-width="200"
                                     class-name="drag"
                                     v-if="dropCol[2].isShow"
                                     :key="dropCol[2].id"
                                     :prop="dropCol[2].prop"
                                     :label="dropCol[2].label"/>
                    <el-table-column class-name="drag"
                                     width="auto"
                                     min-width="220"
                                     v-if="dropCol[3].isShow"
                                     :key="dropCol[3].id"
                                     :prop="dropCol[3].prop"
                                     :label="dropCol[3].label" >
                    </el-table-column>
                    <el-table-column width="auto"
                                     class-name="drag"
                                     v-if="dropCol[4].isShow"
                                     :key="dropCol[4].id"
                                     :prop="dropCol[4].prop"
                                     :label="dropCol[4].label"
                                      min-width="120"/>
                    <el-table-column width="auto"
                                      class-name="drag"
                                      v-if="dropCol[5].isShow"
                                      :key="dropCol[5].id"
                                      :prop="dropCol[5].prop"
                                      :label="dropCol[5].label"
                                      min-width="200" align="center"/>
                    <el-table-column width="auto"
                                      class-name="drag"
                                      v-if="dropCol[6].isShow"
                                      :key="dropCol[6].id"
                                      :prop="dropCol[6].prop"
                                      :label="dropCol[6].label"
                                      min-width="200" align="center"/>
                    <el-table-column width="auto"
                                      class-name="drag"
                                      v-if="dropCol[7].isShow"
                                      :key="dropCol[7].id"
                                      :prop="dropCol[7].prop"
                                      :label="dropCol[7].label"
                                      min-width="200" align="center"/>
                    <el-table-column class-name="drag"
                            fixed="right"
                            v-if="dropCol[8].isShow"
                            :key="dropCol[8].id"
                            :prop="dropCol[8].prop"
                             :label="dropCol[8].label"
                            width="80" align="center">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0" size="mini">已申请</el-tag>
                            <el-tag v-if="scope.row.status == 1" size="mini">已开票</el-tag>
                            <el-tag v-if="scope.row.status == 2" size="mini">已结算</el-tag>
                         </template>
                     </el-table-column>
                    <el-table-column width="220" align="right" fixed="right"
                                     v-if="dropCol[9].isShow"
                                     :key="dropCol[9].id"
                                     :prop="dropCol[9].prop"
                                     :label="dropCol[9].label">
                        <template slot="header"  slot-scope="header">

                            <!--<el-dropdown style="margin-left: 8px;" @command="exportPMS">
                                <el-button type="primary" size="mini">
                                    PMS<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="all">导出全部</el-dropdown-item>
                                    <el-dropdown-item command="selected">导出已选</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>-->
                            <el-dropdown style="margin-left: 8px;" @command="exportDetail">
                                <el-button type="primary" size="mini">
                                    订单明细<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="all">导出全部</el-dropdown-item>
                                    <el-dropdown-item command="selected">导出已选</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-dropdown style="margin-left: 8px;" @command="more">
                                <el-button type="primary" size="mini">
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <!-- <el-dropdown-item command="exportFinanceMoney">导出新物料</el-dropdown-item> -->
                                    <el-dropdown-item command="exportNewMaterial">导出新物料</el-dropdown-item>
                                    <el-dropdown-item command="exportNewSO">导出新销售订单</el-dropdown-item>
                                    <el-dropdown-item command="exportNewPO">导出新采购订单</el-dropdown-item>
                                    <el-dropdown-item command="exportNewPRN">导出新采购入库单</el-dropdown-item>
                                    <el-dropdown-item command="exportErpBidOrder" divided>导出中标</el-dropdown-item>
                                    <el-dropdown-item command="exportErpPO">导出反签</el-dropdown-item>
                                    <el-dropdown-item command="exportErpMaterial">导出物料</el-dropdown-item>
                                    <el-dropdown-item command="exportErpInboundOrder" divided>导出入库单</el-dropdown-item>
                                    <el-dropdown-item command="exportErpOutboundOrder">导出出库单</el-dropdown-item>
                                    <!-- <el-dropdown-item command="exportErpSubmitInvoice">导出交票单</el-dropdown-item> -->
                                    <el-dropdown-item command="exportErpSettlement">导出结算单</el-dropdown-item>
                                    <el-dropdown-item command="exportFinanceInvoiceDetail" divided>导出开票明细</el-dropdown-item>
                                    <!-- <el-dropdown-item command="exportFinanceMoney" divided>导出提报付款</el-dropdown-item> -->
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleToReviewDetail(scope.row)">详情</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-button type="text" size="mini" @click="handleShowInvoice(scope.row)">交票回款</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-dropdown size="mini" >
                                <div style="">
                                     <span class="el-dropdown-link" style="font-size: 12px;vertical-align: middle;line-height: 28px;" >
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                  </span>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <el-button type="text" size="mini" @click="exportProcurementContract(scope.row.id)" style="width: 100%;text-align: left;">订货合同</el-button>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <el-button type="text" size="mini" @click="pushPMS(scope.row.id)" style="color: red;width: 100%;text-align: left;">推送PMS</el-button>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px" v-if="total > 0">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        @size-change="onSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="交票汇款" :visible.sync="dialogInvoice" width="400px">
            <el-form ref="invoiceForm" :model="invoiceForm" :rules="rules2" label-width="90px" size="mini">
                <el-form-item label="销售订单ID" prop="id" hidden>
                    <el-input v-model="invoiceForm.id" placeholder="请输入订单ID" size="mini" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="销售订单号" prop="settlementNo">
                    <el-input v-model="invoiceForm.settlementNo" placeholder="请输入订单编号" size="mini" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="含税总额" prop="price">
                    <el-input v-model="invoiceForm.price" placeholder="请输入发票号" size="mini" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="发票号" prop="invoice">
                    <el-input v-model="invoiceForm.invoice" placeholder="请输入发票号" size="mini" clearable></el-input>
                </el-form-item>
                <el-form-item label="回款日期" prop="paymentCollectionTime">
                    <el-date-picker v-model="invoiceForm.paymentCollectionTime" type='date' placeholder="请选择回款日期" size="mini" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogInvoice = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="handleInvoice" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Sortable from 'sortablejs'//引入插件
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
import { KeepAliveTableMixins } from '../../mixin/KeepAliveTable';
const HEIGHT_OFFSET = 118;
import RightToolBar from "../../components/RightToolBar";

export default {
    mixins: [KeepAliveTableMixins],
    components:{RightToolBar},
    data() {
        return {

            showSearch:false,
            updateTable:"saleTable",
            dropCol:[
                {id:"0",label:'销售订单',prop:'settlementNo',isShow:true},
                {id:"1",label:'子订单',prop:'orderNo',isShow:true},
                {id:"2",label:'公司名称',prop:'companyName',isShow:true},
                {id:"3",label:'收货人',prop:'consignee',isShow:true},
                {id:"4",label:'销售金额(元)',prop:'totalPrice',isShow:true},
                {id:"5",label:'创建时间',prop:'createTime',isShow:true},
                {id:"6",label:'销项发票',prop:'invoice',isShow:true},
                {id:"7",label:'回款日期',prop:'paymentCollectionTime',isShow:true},
                {id:"8",label:'状态',prop:'status',isShow:true},
                {id:"9",label:'操作',prop:'op',isShow:true}],
            //table所有的表头数据
            allTableLabel:[],
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            companys:[],
            money: 0,
            invoiceList:[],
            addressList:[],
            reviewVisible:false,
            searchForm: {
                companyId: "",
                timeDate: "",
                orderNo: "",
                status: "",
            },
            searchFormExport: {},
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            addOrderForm: {
                id: "",
                orderBatch: "",
            },
            exportOrderVisible: false,
            exportOrderForm: {
                orderBatch: "",
            },
            orderForm: {
                orderBatch: "",
            },
            reviewForm: {
                id:"",
                companyId:"",
                invoiceId:"",
                companyName:"",//
                bankName:"",//
                bankAccount:"",//
                companyTaxNo:"",//
                registeredTel:"",//
                registeredAddress:"",//

            },
            addressId:"",
            addressForm: {
                region: {
                    province: '',
                    city: '',
                    area: '',
                    town:""
                },
                id:"",
                mobile:"",
                address:"",//
                consignee:"",//
                county:"",//
                city:"",//
                province:"",//
                provinceId:"",//
                cityId:"",//
                countyId:""//
            },
            selectData:[],//选中的数据
            dialogInvoice: false,
            invoiceForm: {
                id: '',
                settlementNo: '',
                price: '',
                invoice: '',
                paymentCollectionTime: null,
            },
            rules: {
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                consignee: [
                    { required: true, message: '请输入收件人', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],

            },
        }
    },

    methods: {
        //重绘表格
        reDrawTable() {

            this.updateTable = "saleTable"+Math.random();
            this.$nextTick(()=>{

                this.columnDrop();
            });

        },

        doSearch() {
            this.currentPage=1;
            this.onSearch();
        },
        onSearch() {

            this.loading = true;
            this.selectData = [];
            let _this = this;
            let cond = {...this.searchForm};
            if(!this.searchForm.status) {
                cond['status'] = undefined;
            }
            if(this.searchForm.timeDate != "" &&this.searchForm.timeDate!=null) {
                cond["startTime"] = this.searchForm.timeDate[0];
                cond["endTime"] = this.searchForm.timeDate[1];
            }
            this.searchFormExport = {...cond};
            this.$axios.post("/admin/product/order/saleOrder",{
                cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        judgeSelect(row){
            return row.isInvoice == false // 返回true该行可选，返回false则不可选
        },
        selectChanged(invoiceId) {
            if(invoiceId != null && invoiceId != ""){

                let one = null;
                for(let i=0;i<this.invoiceList.length;i++){
                    let item = this.invoiceList[i];
                    if(item.id == invoiceId){
                        one = item;
                    }
                }
                if(one != null) {
                    this.reviewForm = one;
                    this.reviewForm.invoiceId = invoiceId;
                }

            }else{
                this.reviewForm = {};
                this.reviewForm.invoiceId = "";
            }

        },
        addressChanged(addressId) {
            this.addressId = '';
            this.addressId = addressId;
            //this.$set(this.addressForm, 'id', '')
           // this.$set(this.addressForm,'id',addressId);
           // this.$forceUpdate();
            if(addressId != null && addressId != ""){

                let one = null;
                for(let i=0;i<this.addressList.length;i++){
                    let item = this.addressList[i];
                    if(item.id == addressId){
                        one = item;
                    }
                }
                if(one != null){
                    this.addressForm = one;
                    let region = {};
                    if(one.provinceId != null){
                        region.province = one.provinceId;
                    }
                    if(one.cityId != null){
                        region.city = one.cityId;
                    }
                    if(one.countyId != null){
                        region.area = one.countyId;
                    }
                    region.town = '';
                    this.addressForm.region = region;
                }


            }else{

                // this.addressForm.id = addressId;
                // this.addressForm.region = {province:"",city:"",area:"",town:""};
                // this.$set(this.addressForm, this.addressForm.id, '');
                this.addressForm = {
                    region: {
                        province: '',
                            city: '',
                            area: '',
                            town:""
                    },
                    id:"",
                        mobile:"",
                        address:"",//
                        consignee:"",//
                        county:"",//
                        city:"",//
                        province:"",//
                        provinceId:"",//
                        cityId:"",//
                        countyId:""//
                }
            }
            //this.$set(this.addressForm,'id',addressId);

        },
        loadInvoice(){
            let _this = this
            this.$axios.post("/admin/invoice/customer/list"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.invoiceList = resp.data;
                }

            });

        } ,
        loadAddress(){
            let _this = this
            this.$axios.get("/admin/address/getAddress"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.addressList = resp.data;
                }

            });

        } ,
        regionChange (data) {

            //{"province":{"key":"130000","value":"河北省"},"city":{"key":"130100","value":"石家庄市"},"area":{"key":"130105","value":"新华区"}}

            if(data.province != null){
                this.addressForm.province = data.province.value;
                this.addressForm.provinceId = data.province.key;
            }

            if(data.city != null){
                this.addressForm.city = data.city.value;
                this.addressForm.cityId = data.city.key;
            }
            if(data.area != null){
                this.addressForm.county = data.area.value;
                this.addressForm.countyId = data.area.key;
            }

        },
        saveAddress() {
            const that = this;
            this.$refs.addressForm.validate(valid => {
                if(valid) {
                    this.$axios.post("/admin/address/save", this.addressForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                // that.$notify({
                                //     title: '成功',
                                //     message: '数据保存成功',
                                //     type: 'success'
                                // });
                                that.addressId = resp.data.id;
                                that.saveSettlement();
                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            });
        },

        showReviewDialog() {//打开发票对话框
            this.reviewForm =
                {
                    id: "",
                    companyId: "",
                    invoiceId: "",
                    companyName: "",//
                    bankName: "",//
                    bankAccount: "",//
                    companyTaxNo: "",//
                    registeredTel: "",//
                    registeredAddress: ""
                };
            this.clearIt();
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要开发票的订单',
                    duration: 2000
                });
                return;
            }
            this.loadInvoice();
           // if(this.addressList.length==0){
                this.loadAddress();
           // }
            //this.loadAddress();
            this.money = 0;
            this.selectData.map(it => {this.money = this.money+it.totalPrice});
            if(this.money){
                this.money = this.money.toFixed(2);
            }
            this.reviewVisible = true;

        },
        clearIt(){
            this.addressId = "";
            this.addressForm={
                region: {
                    province: '',
                    city: '',
                    area: '',
                    town: ''
                },
                id:"",
                mobile:"",
                address:"",//
                consignee:"",//
                county:"",//
                city:"",//
                province:"",//
                provinceId:"",//
                cityId:"",//
                countyId:""
            }
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        onSizeChange(val) {
            this.pageSize = val;
            this.onSearch();
        },
        saveSettlement(){
            const that = this;
            let data = {};
            data.invoiceId = this.reviewForm.invoiceId;
            data.addressId = this.addressId;

            let ids =  this.selectData.map(it => it.id);
            data.orderIds = ids;
            data.companyId = this.reviewForm.companyId;
            data.companyName = this.reviewForm.companyName;

            this.$axios.post("/admin/invoice/saveSettlement", data)
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据保存成功',
                            type: 'success'
                        });
                        that.onSearch();
                        that.reviewVisible = false;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },
        addVoice(){//确定开发票

            if(this.reviewForm.invoiceId=="" ||this.reviewForm.invoiceId == null ){
                this.$message({
                    type: 'info',
                    message: '请选择发票',
                    duration: 1000
                });
                return;
            }
            if(this.addressId=="" ||this.addressId == null ){
                this.saveAddress();

            }else{
                this.saveSettlement();
            }
        },

        handleToReviewDetail(row) {
            this.$router.push({name: "saleOrderDetail", params:{id: row.id,title:'销售订单',info:row.settlementNo}});
            // this.$router.push({name: "settlementDetail", params: {from: "settlement", settlementNo: row.settlementNo,
            //         id:row.id,totalPrice:row.totalPrice,code:row.code,companyName:row.companyName,createTime:row.createTime}});
        },
        handleShowInvoice(row) {
            this.invoiceForm = {
                id: row['id'],
                settlementNo: row['settlementNo'],
                price: row['totalPrice'],
                invoice: row['invoice'],
                paymentCollectionTime: row['paymentCollectionTime'],
            }
            this.dialogInvoice = true;
        },
        handleInvoice() {
            const that = this;
            this.$axios.post("/admin/product/order/saleOrderInvoice", {
                id: this.invoiceForm['id'],
                invoice: this.invoiceForm['invoice'],
                paymentCollectionTime: this.invoiceForm['paymentCollectionTime'],
            }
            ).then(function (response) {
                const { data: resp } = response;
                if (resp.header.status == 0) {
                    that.onSearch();
                    that.dialogInvoice = false;
                } else {
                    that.$message({
                        type: 'error',
                        message: resp.header.msg,
                        duration: 2000
                    });
                }
            });
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        loadCompanys(){
            let _this = this
            this.$axios.post("/admin/company/customerCompanies"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }
            });

        },
        exportDetail(command){
            let all = false;
            let cond = {...this.searchFormExport};
            switch(command) {
                case 'all': {
                    all = true;
                    break;
                }
                case 'selected': {
                    if (this.selectData.length == 0) {
                        this.$message({
                            type: 'error',
                            message: '请选择要导出的订单',
                            duration: 2000
                        });
                        return;
                    }
                    cond = {};
                    let arr = [];
                    let val = this.selectData;
                    if(val.length>0) {
                        for (let i = 0; i < val.length; i++) {
                            arr.push(val[i].id);
                        }
                        cond = arr;
                    }
                    break;
                }
            }

            const that = this;
            let url = "/admin/order/exportDetail";

            if(all) {
                url =  "/admin/order/exportAllDetail";
            }
            downloadByPost({
                axios: that.$axios,
                url: url,
                data: cond,
                success: response => {
                    convertRes2Blob(response);
                },
            });


        },
        exportPMS(command){
            let all = false;
            let cond = {...this.searchFormExport};
            switch(command) {
                case 'all': {
                    all = true;
                    break;
                }
                case 'selected': {
                    if (this.selectData.length == 0) {
                        this.$message({
                            type: 'error',
                            message: '请选择要导出的订单',
                            duration: 2000
                        });
                        return;
                    }
                    all = false;
                    cond = {};
                    let arr = [];
                    let val = this.selectData;
                    if(val.length>0) {
                        for (let i = 0; i < val.length; i++) {
                            arr.push(val[i].id);
                        }
                        cond = arr;
                    }
                    break;
                }
            }

            const that = this;
            let url = "/admin/easypoi/pms";
            if(all) {
                url = "/admin/easypoi/allPms";
            }
            this.pageLoading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            downloadByPost({
                axios: that.$axios,
                url: url,
                data: cond,
                success: response => {
                    convertRes2Blob(response);
                },
                faild: () => {
                    this.$message({
                        type: 'error',
                        message: '导出失败',
                        duration: 2000
                    });
                },
                complete: () => {
                    this.pageLoading.close();
                    this.pageLoading = undefined;
                }
            });


        },
        more(command){
            if(command && command.length > 6 && command.substr(0,6)==="export") {
                if (this.selectData.length == 0) {
                    this.$message({
                        type: 'error',
                        message: '请选择要导出的订单',
                        duration: 2000
                    });
                    return;
                }
                const ids = this.selectData.map(it => it["id"]);
                this.pageLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                downloadByPost({
                    axios: this.$axios,
                    url: `/admin/order/${command}`,
                    data: ids,
                    success: response => {
                        convertRes2Blob(response);
                    },
                    faild: () => {
                        this.$message({
                            type: 'error',
                            message: '导出失败',
                            duration: 2000
                        });
                    },
                    complete: () => {
                        this.pageLoading.close();
                        this.pageLoading = undefined;
                    }
                });
            }
        },
        andleSelectionChange(val) {
            this.selectData = val;
        },
        handleToDeliver(row) {
            this.viewDeliverVisible = true;
            this.$router.push({name: "saleOrderDeliver", params: {from: "order", orderId: row.id}});
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            if (!tablePosition) {
                // 如果 ref 还没准备好，延迟重试
                this.$nextTick(() => {
                    this.setTableHeight();
                });
                return;
            }
            try {
                const {top} = tablePosition.getBoundingClientRect();
                const calculatedHeight = window.innerHeight - top - HEIGHT_OFFSET;
                // 确保高度至少为200，避免表格不显示
                this.tableConfig.height = Math.max(calculatedHeight, 200);
            } catch (e) {
                console.error('计算表格高度失败:', e);
                // 设置一个默认高度，避免表格不显示
                this.tableConfig.height = 400;
            }
        },
        exportProcurementContract(id){
            this.pageLoading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            downloadByPost({
                axios: this.$axios,
                url: '/admin/product/order/exportProcurementContract/' + id,
                success: response => {
                    convertRes2Blob(response);
                },
                faild: () => {
                    this.$message({
                        type: 'error',
                        message: '合同导出失败',
                        duration: 2000
                    });
                },
                complete: () => {
                    this.pageLoading.close();
                    this.pageLoading = undefined;
                }
            });

        },
        pushPMS(id) {
            const that = this;
            this.$confirm('是否确定推送?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post("/admin/invoice/pushSettlement2PMS", {id})
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据推送成功',
                            type: 'success'
                        });
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            });
        },
        //列拖拽
        columnDrop(){
            try{
            //const wrapperTr = this.$refs.dataTable.$el.querySelector('.el-table__header-wrapper tr');
            const wrapperTr = document.querySelector('.el-table__header-wrapper tr');
            let oldLabel;
            let newLabel;
            let oldIndex;
            let newIndex;
            let count=0;
            const that=this;
            this.sortable = Sortable.create(wrapperTr, {
                animation: 180,
                delay: 30,
                draggable:".drag",
                onEnd: evt => {
                          oldLabel=this.$refs.dataTable.columns[evt.oldIndex].property;
                          newLabel=this.$refs.dataTable.columns[evt.newIndex].property;
                          for (let i=0;i<that.dropCol.length;i++){
                              if (that.dropCol[i].prop!=undefined&&that.dropCol[i].prop==newLabel)
                                  newIndex=i;

                          }

                          for (let j=0;j<that.dropCol.length;j++){
                              if (that.dropCol[j].prop!=undefined&&that.dropCol[j].prop==oldLabel)
                                  oldIndex=j;
                          }

                          const oldItem = this.dropCol[oldIndex];
                          this.dropCol.splice(oldIndex, 1);
                          this.dropCol.splice(newIndex, 0, oldItem);

                          this.dropCol.forEach((item)=>{
                              if(item.prop==newLabel||item.prop==oldLabel){
                                  item.id=new Date().getTime() + (++count)+"";
                                  //console.log(JSON.stringify(this.dropCol));// eslint-disable-line
                              }
                          })



                },
            });
            }catch (e) {
                console.log(e);// eslint-disable-line
            }
        },


    },
    mounted() {

        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        // 使用 nextTick 确保DOM已渲染，然后延迟设置高度
        this.$nextTick(() => {
            setTimeout(() => {
                this.setTableHeight();
                if (this.pageLoading) {
                    this.pageLoading.close();
                    this.pageLoading = undefined;
                }
            }, 500);
        });


        this.columnDrop();

    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    activated() {
        // 使用 nextTick 确保DOM已渲染
        this.$nextTick(() => {
            setTimeout(() => {
                this.setTableHeight();
                if (this.pageLoading) {
                    this.pageLoading.close();
                    this.pageLoading = undefined;
                }
            }, 100);
        });
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    },
    created() {
        this.onSearch();
        this.loadCompanys();
        //this.setTableShow();
        window.addEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
    .el-table th.gutter{

        display: table-cell!important;

    }
    .item {

        margin-bottom: 0px;

    }
    .item1 {
        margin-top: -10px;
        margin-bottom: 0px;

    }
    ::v-deep .el-table__body .el-table__row:nth-child(n) td {
        background-color: #fff !important;
    }
</style>